import React, { useEffect, useState } from 'react'
import { ActionIcon, Group, TextInput, Title } from "@mantine/core"
import { IconCheck, IconPencil, IconX } from "@tabler/icons-react"
import { PricingVersion } from '../../GlobalJobMatchingVersioning/types/versions'
import { useUpdatePricingVersion } from '../../../../hooks/global-job-matching'
import { notifications } from '@mantine/notifications'
import { useFocusTrap } from '@mantine/hooks'

export const EditableTitle = ({ version }: { version: PricingVersion }) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const [value, setValue] = useState<string>(version?.name)
  const { mutate: updateVersion, isError, reset } = useUpdatePricingVersion(version?.id?.toString())

  const focusTrapRef = useFocusTrap(isEditMode)

  const handleUpdateName = () => {
    updateVersion({ name: value })
    setIsEditMode(false)
  }

  useEffect(() => {
    if (isError) {
      notifications.show({ message: 'Error renaming version. This version name may already exist', color: 'red' })
      reset()
    }
  }, [isError])

  useEffect(() => {
    if (version || !isEditMode) setValue(version.name)
  }, [version, isEditMode])

  if (!version) return

  return (
    <Group>
      { !isEditMode ?
        <>
          <Title style={{ fontWeight: 600 }}>{version?.name}</Title>
          <ActionIcon color='newGrey.7' variant='transparent' onClick={() => setIsEditMode(true)}>
            <IconPencil />
          </ActionIcon>
        </> :
        <>
          <TextInput 
            ref={focusTrapRef}
            size='xl'
            value={value}
            style={{ fontSize: '20px' }}
            onChange={e => setValue(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') handleUpdateName()
            }}
          />
          <ActionIcon size='lg'color='green' onClick={handleUpdateName}>
            <IconCheck />
          </ActionIcon>
          <ActionIcon size='lg' color='red' onClick={() => setIsEditMode(false)}>
            <IconX />
          </ActionIcon>
        </>
      }
    </Group>

  )
}
